import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import blue from '../assets/bluearrow.png'
import white from '../assets/search.png'

let bannertxt=`is a reference site providing access to research and publications of faculty, staff and students of College of Islamic Studies, Hamad Bin Khalifa University.`
let bannertxt2=`In addition, it includes a dedicated bibliographic database on Islamic Economics and Finance.`

class Homesearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            option: "Publication",
            option_show: false,
            keyword: '',
            searchfilter: ''
        };
    }

    _handleKeyPress(e) {

        if (e.key === 'Enter') {
            this.search()
        }
    }

    fillalert(msg) {
        this.setState({
            filltext: msg,
            fillalert: true
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null
                })
            }
                .bind(this),
            3000
        );
    }


    search() {
        if (this.state.keyword.length < 3) {
            // alert("Enter atleast 3 characters")
            this.fillalert("Enter atleast 3 characters")

        }
        else
            // window.location.href = '/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20')
        this.props.history.push('/search/'+this.state.keyword.replace(/\//g, '%20').replace(',', '%20'))
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    render() {


        return (

            <div className="newhomesearch">
                {this.state.fillalert ? <div className="fill-alert">{this.state.filltext}</div> : ''}
                <div className="container">
                    <div className="searchcontainer">
                    <div className="searchtext">
                            <div className="searchtext_block">
                                {/* <div><Link to='/about'>I-BIR</Link></div> */}
                                <div className="italictext">Islamic Bibliographic Info Repository</div>
                            </div>
                            <div className="searchsubtext">
                                <div>{bannertxt}</div>
                                <div>{bannertxt2}</div>
                            </div>
                        </div>
                        <div className="newsearchdiv">
                        
                                {/* <div>{this.state.option}</div> */}
                                {/* <img src={blue} alt="blue" /> */}
                                {/* <ul style={{ display: this.state.option_show ? '' : 'none' }} className="options">
                                    <li
                                        onClick={() => this.setState({
                                            option_show: !this.state.option_show
                                        })}  >
                                        Entire Website
                                    </li>

                                    <li
                                        onClick={() => this.setState({
                                            option_show: !this.state.option_show
                                        })}  >
                                        Research
                                    </li>
                                    <li
                                        onClick={() => this.setState({
                                            option_show: !this.state.option_show
                                        })}  >
                                        Financial Inst.
                                    </li>
                                </ul> */}
                            <input type="text" placeholder="Search I-BIR" name="keyword" value={this.state.keyword} size="40" minLength="3" maxLength={120} onChange={e => { this.handleChange(e) }} onKeyPress={(e) => this._handleKeyPress(e)} style={{borderRight:'none'}}/>
                            <div className="newsearchicon">
                                <img onClick={() => this.search()} src={white} alt='white' />
                            </div>
                        </div>
                        <Link to="/about" className="overlaylink">

                        </Link>
                    </div>
                </div>
            </div>

        );
    }
}

export default Homesearch;